import React, { useLayoutEffect, useEffect, forwardRef } from 'react';
import { Suspense, lazy } from '@uploadcare/client-suspense';
import 'react-fast-compare';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var isReactNative = typeof global !== 'undefined' && global.navigator && global.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 */

var useIsomorphicEffect = isDOM || isReactNative ? useLayoutEffect : useEffect;

var Uploader = /*#__PURE__*/lazy(function () {
  return import(
  /* webpackChunkName: "ucare-widget-chunk" */
  './uploader-52eab90f.js');
});
var Dialog = /*#__PURE__*/lazy(function () {
  return import(
  /* webpackChunkName: "ucare-panel-chunk" */
  './dialog-38cb2708.js');
});

var Config = function Config(_ref) {
  var locale = _ref.locale,
      localeTranslations = _ref.localeTranslations,
      localePluralize = _ref.localePluralize;
  useIsomorphicEffect(function () {
    window.UPLOADCARE_INTEGRATION = 'react-widget';
    window.UPLOADCARE_LIVE = false;
    window.UPLOADCARE_MANUAL_START = true;
  }, []); // configurate translations

  useIsomorphicEffect(function () {
    window.UPLOADCARE_LOCALE = window.UPLOADCARE_LOCALE || locale;
    window.UPLOADCARE_LOCALE_TRANSLATIONS = window.UPLOADCARE_LOCALE_TRANSLATIONS || localeTranslations;
    window.UPLOADCARE_LOCALE_PLURALIZE = window.UPLOADCARE_LOCALE_PLURALIZE || localePluralize; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

var Widget = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var locale = _ref2.locale,
      localeTranslations = _ref2.localeTranslations,
      localePluralize = _ref2.localePluralize,
      _ref2$preloader = _ref2.preloader,
      preloader = _ref2$preloader === void 0 ? 'Loading...' : _ref2$preloader,
      props = _objectWithoutProperties(_ref2, ["locale", "localeTranslations", "localePluralize", "preloader"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Config, {
    locale: locale,
    localeTranslations: localeTranslations,
    localePluralize: localePluralize
  }), /*#__PURE__*/React.createElement(Suspense, {
    fallback: preloader
  }, /*#__PURE__*/React.createElement(Uploader, _extends({}, props, {
    apiRef: ref
  }))));
});
var Panel = function Panel(_ref3) {
  var locale = _ref3.locale,
      localeTranslations = _ref3.localeTranslations,
      localePluralize = _ref3.localePluralize,
      _ref3$preloader = _ref3.preloader,
      preloader = _ref3$preloader === void 0 ? 'Loading...' : _ref3$preloader,
      props = _objectWithoutProperties(_ref3, ["locale", "localeTranslations", "localePluralize", "preloader"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Config, {
    locale: locale,
    localeTranslations: localeTranslations,
    localePluralize: localePluralize
  }), /*#__PURE__*/React.createElement(Suspense, {
    fallback: preloader
  }, /*#__PURE__*/React.createElement(Dialog, props)));
};

export { Panel as P, Widget as W, _extends as _, _objectWithoutProperties as a, _slicedToArray as b, _objectSpread2 as c, _defineProperty as d };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/react-widget/dist/esm/index-97ee4443.js
// module id = 882
// module chunks = 70